"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n\tquery getUserID {\n\t\tviewer {\n\t\t\tuser {\n\t\t\t\tid\n\t\t\t}\n\t\t}\n\t}\n"], ["\n\tquery getUserID {\n\t\tviewer {\n\t\t\tuser {\n\t\t\t\tid\n\t\t\t}\n\t\t}\n\t}\n"]),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(["\n\tmutation CreateNewOrg {\n\t\tcreateOrg(input: { name: \"New Org\" }) {\n\t\t\tchangedOrg {\n\t\t\t\tid\n\t\t\t\timage {\n\t\t\t\t\turi\n\t\t\t\t\tcloudinaryID\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"], ["\n\tmutation CreateNewOrg {\n\t\tcreateOrg(input: { name: \"New Org\" }) {\n\t\t\tchangedOrg {\n\t\t\t\tid\n\t\t\t\timage {\n\t\t\t\t\turi\n\t\t\t\t\tcloudinaryID\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"]),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(["\n\tmutation AddOrgToUser($input: AddToUserOrgAdminConnectionInput!) {\n\t\taddToUserOrgAdminConnection(input: $input) {\n\t\t\tchangedUserOrgAdmin {\n\t\t\t\tuser {\n\t\t\t\t\tid\n\t\t\t\t\tusername\n\t\t\t\t}\n\t\t\t\torg {\n\t\t\t\t\tid\n\t\t\t\t\tname\n\t\t\t\t}\n\t\t\t}\n\t\t\tviewer {\n\t\t\t\tuser {\n\t\t\t\t\tid\n\t\t\t\t\tmemberOf {\n\t\t\t\t\t\tedges {\n\t\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tadminOf {\n\t\t\t\t\t\tedges {\n\t\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"], ["\n\tmutation AddOrgToUser($input: AddToUserOrgAdminConnectionInput!) {\n\t\taddToUserOrgAdminConnection(input: $input) {\n\t\t\tchangedUserOrgAdmin {\n\t\t\t\tuser {\n\t\t\t\t\tid\n\t\t\t\t\tusername\n\t\t\t\t}\n\t\t\t\torg {\n\t\t\t\t\tid\n\t\t\t\t\tname\n\t\t\t\t}\n\t\t\t}\n\t\t\tviewer {\n\t\t\t\tuser {\n\t\t\t\t\tid\n\t\t\t\t\tmemberOf {\n\t\t\t\t\t\tedges {\n\t\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tadminOf {\n\t\t\t\t\t\tedges {\n\t\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _recompose = require("recompose");

var _reactApollo = require("react-apollo");

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//------------------------------

var getUserID = (0, _reactApollo.gql)(_templateObject);

var createNewOrg = (0, _reactApollo.gql)(_templateObject2);

var addOrgToUser = (0, _reactApollo.gql)(_templateObject3);

var enhance = (0, _recompose.compose)((0, _reactApollo.graphql)(getUserID, {
	name: "getUserID"
}), (0, _reactApollo.graphql)(createNewOrg, {
	props: function props(_ref) {
		var mutate = _ref.mutate;
		return {
			createNewOrg: function createNewOrg(myID) {
				return mutate({
					variables: {
						myID: myID
					}
				});
			}
		};
	}
}), (0, _reactApollo.graphql)(addOrgToUser, {
	props: function props(_ref2) {
		var mutate = _ref2.mutate;
		return {
			addOrgToUser: function addOrgToUser(_ref3) {
				var orgId = _ref3.orgId,
				    userId = _ref3.userId;
				return mutate({
					variables: {
						input: {
							orgId: orgId,
							userId: userId
						}
					}
				});
			}
		};
	}
}), (0, _recompose.withHandlers)({
	addNewOrg: function addNewOrg(props) {
		return function () {
			return props.createNewOrg().then(function (resp) {
				var newOrgId = _ramda2.default.path(["data", "createOrg", "changedOrg", "id"])(resp);
				var userId = _ramda2.default.path(["getUserID", "viewer", "user", "id"])(props);
				return newOrgId && userId ? props.addOrgToUser({
					orgId: newOrgId,
					userId: userId
				}) : Promise.reject(resp);
			});
		};
	}
}));

exports.default = enhance(function (props) {
	return _ramda2.default.path(["getUserID", "viewer", "user", "id"], props) ? _react2.default.createElement(
		_styles.AddOrgButton,
		{ onClick: props.addNewOrg, title: "Add new org" },
		"Add new org"
	) : null;
});

//# sourceMappingURL=addNewButton.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/components/shell/button/addNewButton.js
// module id = 376
// module chunks = 0